<template>
  <div v-if="aConfiguracion.permisos.priv_access == '1'">
    <v-sheet color="dark" v-if="cargando">
      <v-skeleton-loader
        :loading="true"
        class="mx-auto"
        max-width="100%"
        type="table-heading, table-thead, table-tbody, table-row-divider"
      />
    </v-sheet>
    <v-data-table
      v-show="!cargando"
      v-model="selected"
      :headers="aFormatHeaders"
      :items="dataItems"
      :single-select="bSingleSelect"
      :search="quitSearch"
      :items-per-page.sync="itemsPerPagina"
      :page.sync="paginaselect"
      :item-key="sIdTable"
      :loading="cargando"
      :show-select="bShowSelect"
      :show-expand="bGridAnidada"
      :single-expand="true"
      :expanded.sync="aDataParaAnidada"
      hide-default-footer
      dense
      class="rounded-basic"
      fixed-header
      :height="cmpAltoTabla"
      disable-sort
      :mobile-breakpoint="nVistaTabla"
    >
    <template v-slot:top >
        <v-container class="px-1 pt-1 pb-0 mb-1" v-if="cabeceraVisible">
          <v-row align="center" class="no-gutters" justify="start">
            <v-col cols="12" lg="4" md="4" sm="12" xs="12" class="py-0 d-flex justify-start align-center">
              <v-text-field
                v-model="quitSearch"
                label=" Busqueda Rápida"
                append-icon="fa-search"
                background-color="white"
                flat
                hide-details
                rounded
                dense
                tile
                outlined
                class="container-search"
                >
              </v-text-field>
              <v-btn small depressed dark v-if="bActiveFilter" color="primary" :outlined="!bFiltrarActive" active-class="btn-active-filtro" class="no-uppercase ml-1" @click="onFiltrar()" rounded>
                <v-icon left>mdi-filter-outline</v-icon>
                Filtrar
              </v-btn>
              <v-btn fab elevation="0" color="btndest" :outlined="bMostrarOpciones" dark x-small class="ml-1" v-if="$vuetify.breakpoint.xs" @click="bMostrarOpciones = !bMostrarOpciones"> <v-icon small>mdi-tools</v-icon> </v-btn>
            </v-col>
            <v-expand-transition> 
            <v-col v-if="$vuetify.breakpoint.xs ? !bMostrarOpciones : !$vuetify.breakpoint.xs " cols="12" lg="8" md="8" sm="12" xs="12" class="d-flex no-gutters row wrap justify-end d-flex cont-acciones">
              <v-menu
                v-if="bActiveExport"
                class="d-flex mx-2"
                offset-y
                :close-on-content-click="false"
                transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" @click="exportinfo()" color="primary" outlined class="no-uppercase my-1" small depressed rounded> 
                    <v-icon left>mdi-export</v-icon>
                    {{ $store.state.jsIdioma.oEquivalencias.btnExportar }} 
                  </v-btn>
                </template>
                <v-list
                  dense>
                  <v-list-item @click="onExportar('xlsx','rango')">
                    <v-list-item-content>
                      <v-list-item-title><v-icon left>fa-file-excel</v-icon>{{$store.state.jsIdioma.oEquivalencias.btnExportarInfoRangoFecha}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <slot name="slotbtnNew"></slot>
              <v-btn v-if="bActiveNew && aConfiguracion.permisos.priv_insert == '1'" color="primary" class="no-uppercase my-1" small depressed dark @click="nuevoItem" rounded>
                <v-icon left>mdi-plus</v-icon>
                Nuevo
              </v-btn>
            </v-col>
            </v-expand-transition>
          </v-row>
          <!-- BARRA DE FILTROS ACTIVOS -->
          <v-row no-gutters v-if="aListadoFiltrosFinal.length >= 1">
            <div class="filtros-activos-mensaje mt-2">
              <span class="filtros-activos">Filtros activos: &nbsp;</span>
              <v-chip x-small class="mx-1" color="white" v-for="(f, i) in getaInfoFiltrada" :key="'nomFiltro-'+i" @click="onFiltrar">
                {{f.Titulo}} : {{f.Valor}}
              </v-chip>
               <!-- <span v-for="f in aListadoFiltrosFinal" :key="f">{{f}}, &nbsp;</span> -->
            </div>
          </v-row>
          <v-row class="d-flex justify-end align-center no-gutters" v-if="$vuetify.breakpoint.xs">
            <span class="color-primary text-size-05">Cambiar visualización</span>
            <v-btn :color="nVistaTabla != 0 ? 'btncolor': 'gray'" icon dense small @click="nVistaTabla = 600"><v-icon>mdi-card-text-outline</v-icon></v-btn>
            <v-btn :color="nVistaTabla == 0 ? 'btncolor': 'gray'" icon dense small @click="nVistaTabla = 0" class="mx-1"><v-icon>mdi-table-large</v-icon></v-btn>
          </v-row>
        </v-container>
        <!-- CONTAINER DEL FILTRO -->
        <FilterSecction
          ref="FilterSecction"
          v-model="bFiltrarActive"
          :aHeaders="headers"
          :bSubdominioTemporal="bSubdominioTemporal"
          @ejecutarFiltro="onGetFiltrarInicio"
          @listadoFiltros="on_aListadoFiltros"
          @aFiltrosActivos="on_aFiltrosActivos"
          @LimpiarFiltrosComponente="onLimpiarFiltros()">
        </FilterSecction>
      </template>
      <!-- CELDAS DEL GRID item tienen el dato a mostrar -- formatHeader tienen la info de la cabecera -- field.value tienen el nombre del campo-->
      <template
        v-slot:[`item.${field.value}`]="{ item }"
        v-for="(field, indexEncabezado) in aFormatHeaders"
      >
        <div
          :key="indexEncabezado"
          :class="`rounded ${getAlineacion(field.alineacion)}`"
          :style="'backgroundColor:' + getColor(item, field.value) + ';'"
        >
          <component
            :is="field.tipo"
            :texto="item[`${field.value}`]"
            :titulo="field.text"
            :class="{ 'text-inverted': getColor(item, field.value) }"
            :oDataParent="item"
            :sCampo="field.value"
            :sTabla="tabla"
            :sTipo="field.tipo"
            @onCeldaCambio="onCeldaCambio"
            :sIdTable="sIdTable"
            class="font-grid"
            :oPermisos="aConfiguracion.permisos"
          >
            <!-- :color="getColor(item, field.value)" -->
          </component>
        </div>
      </template>

      <!-- GRID ANIDADA -->
      <template v-slot:expanded-item="{ item }">
        <td :colspan="12" class="pa-3 under-sec-flat">
          <slot name="slot-grid-anidada" :item="item"></slot>
        </td>
      </template>
      <!-- COLUMNA DE ACCIONES -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu transition="slide-x-transition" bottom right min-width="200px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="btn-mas"
              v-if="BtnAcciones.length >= 4"
              fab
              outlined
              elevation="0"
              color="primary"
              x-small
              v-bind="attrs"
              v-on="on"
              ><v-icon>mdi-playlist-plus</v-icon>
            </v-btn>
          </template>
          <div class="cont-btn-more">
            <div
              v-for="(boton, index) in BtnAcciones"
              :key="'dos' + index"
              class="item-btn-more"
            >
              <BtnGrid
                v-if="onValidarBoton(boton.componente, item)"
                :typebtn="boton.componente"
                :item="item"
                :HoverMensaje="boton.mensaje"
                :tabla="tabla"
                :oPermisos="aConfiguracion.permisos"
                :oProps="boton.oProps"
                @btnActionEvento="btnActionEvento"
              >
                <template v-slot:slotTextoMensaje>
                  {{ boton.mensaje }}
                </template>
              </BtnGrid>
            </div>
          </div>
        </v-menu>
        <div class="container__comp--btn" v-if="BtnAcciones.length <= 3">
          <div v-for="(boton, index) in BtnAcciones" :key="'dos' + index">
            <BtnGrid
              v-if="onValidarBoton(boton.componente, item)"
              :typebtn="boton.componente"
              :item="item"
              :HoverMensaje="boton.mensaje"
              :tabla="tabla"
              :oPermisos="aConfiguracion.permisos"
              :oProps="boton.oProps"
              @btnActionEvento="btnActionEvento"
            >
            </BtnGrid>
          </div>
        </div>
      </template>
      <!-- FOOTER DE GRID GENERAL -->
      <template v-slot:footer>
        <v-divider></v-divider>
        <v-row class="pa-0 ma-0 justify-start align-center mt-2 cont-footer">
          <v-col
            cols="12"
            sm="12"
            md="5"
            lg="4"
            class="col-nopadding col-registros"
          >
            <v-row justify-center class="no-gutters">
              <v-col
                sm="6"
                lg="6"
                cols="6"
                class="d-flex justify-center align-center col-nopadding"
              >
                <v-chip class="ma-2" text-color="black" color="white">
                  <span class="text-primary text-registros-totales"
                    >Registros Totales</span
                  >
                  <div class="resaltado">
                    <span> &nbsp;{{ totalRegistros }} </span>
                  </div>
                </v-chip>
              </v-col>
              <v-col
                sm="6"
                lg="6"
                cols="6"
                class="d-flex justify-center align-center pa-1"
              >
                <span class="mr-1 text-primary text-registros">No. Registro</span> 
                <v-select
                  class="text-primary select-registros pa-0 ma-0"
                  v-model="itemsPerPagina"
                  :items="itemsPagina"
                  dense
                  outlined
                  hide-details
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="5"
            lg="6"
            class="d-flex justify-center align-center cont-shadown-up py-2"
          >
            <v-pagination
              v-model="paginaselect"
              :circle="false"
              :length="pageLength"
              :total-visible="pageTotalVisible"
              :page="paginaselect"
              class=""
            >
            </v-pagination>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <formulario
      v-if="(bActiveNew || bFormularioTemporal || bEditItem) && showNew"
      :key="keyForm"
      v-model="showNew"
      :tableName="onCargarOrigenFormulario('Tabla')"
      @saveOK="onRefrescarItems(), onDatosGuardados()"
      :modNuevo="formNew"
      :oItem.sync="itemEdit"
      :oDetalle="oDetalleFormulario"
      :sDetalleTitulo="sDetalleTitulo"
      :idItem="sIdTable"
      :sCampoFiltro="sCampoFiltro"
      :oDataFormularioAdicional="oDataFormularioAdicional"
      :nIdValor="nIdValor"
      :aParametros="aParametros"
      :bSubdominioTemporal="bSubdominioTemporal"
    >
    </formulario>

    <!-- COMPONENTE PARA VISUALIZAR REPORTE -->
    <VistaDetalle
      v-if="detalleVer"
      v-model="detalleVer"
      :oParent.sync="oProps"
      :sNameDetails="sDetallesCasoCorreo"
      :sNameTablePrin="tabla"
      :sIdCampo="sIdTable"
      :aParametros="aParametros"
      :bSubdominioTemporal="bSubdominioTemporal"
    >
    </VistaDetalle>
    <!-- BOTONES DE GRID -->
    <ModalAddUser
      v-if="bShowAdd"
      :key="keyForm + 1"
      :bShowAddUser="bShowAdd"
      :sTable="ClientesXUsuarios"
      :oParent.sync="oProps"
      :sTitle="'Añadir Usuarios'"
      @input="setModalFalse()"
    >
    </ModalAddUser>
    <FormColor
      v-if="bShowColor"
      :bShowMdlColor="bShowColor"
      :titulo="'Configura el color de tu cliente'"
      :oDataParent.sync="oProps"
      :sTable="tabla"
      @input="setModalFalse()"
    >
    </FormColor>
    <FormMapa
      v-if="bShowMapa"
      :bShowMap="bShowMapa"
      :oDataParent.sync="oProps"
      @input="setModalFalse()"
    >
    </FormMapa>
    <!--slot name="slot-dialog-firmas" :oItem="oProps" :isModal="bMostrarFirmas" :onCerrarDialog="setModalFalse()"></slot!-->
    <DialogFirmas
      v-if="bMostrarFirmas"
      :bMostrarModal="bMostrarFirmas"
      :oDataParent.sync="oProps"
      :sNombreTabla="tabla"
      :sIdCampo="sIdTable"
      @input="setModalFalse()"
    />

    <DialogImagenes
      v-if="bMostrarImagenes"
      :bMostrarModal="bMostrarImagenes"
      :oDataParent.sync="oProps"
      :sNombreTabla="tabla"
      :sIdCampo="sIdTable"
      @input="setModalFalse()"
    />

    <ExportModal
      v-if="bActiveExport"
      :bShowExport="bShowEx"
      :sTable="tabla"
      :TypeExport="sPropsType"
      :oFiltro="cmpGetoParamsFiltro"
      :nPage="nPropPageSel"
      :nPerPage="nPropsItemPerPage"
      :bAllExport="bExportAll"
      :aInfoTBDetalleExp="aInfoTBDetalleExp"
      :bSubdominioTemporal="bSubdominioTemporal"
      :aRangoExportarTodo="aExportarTodo"
      :sIdTable="sIdTable"
      @input="setModalFalse()"
    >
    </ExportModal>
    <BtnConvertir
      :oDataParent="oProps"
      :bShowConvertir="bConvertir"
      @refrescar="onRefrescarItems"
      @input="setModalFalse()"
    >
    </BtnConvertir>
    <DialogAnexos
      v-if="bMostrarAnexos"
      :bMostrarModal="bMostrarAnexos"
      :oDataParent.sync="oProps"
      :sNombreTabla="tabla"
      :sIdCampo="sIdTable"
      @onCerrarDialog="bMostrarAnexos = false"
     />

    <DialogoFechaRangoExportar
      v-model="bDialogoFechaExportar"
      @onExportarRango="onRangoExportar"
    >
    </DialogoFechaRangoExportar>

    <v-dialog
      v-model="bMostrarFormDinamico"
      persistent
      max-width="800px"
      max-height="80vh"
    >
      <v-card class="pa-0 cont-dialog-scroll">
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer></v-spacer>
          <span class="text-semibold subtitulo"> Formulario Dinámico </span>
          <v-spacer></v-spacer>
          <v-btn
            color="btncolor-dark"
            dark
            @click="(bMostrarFormDinamico = false), (itemEdit = {})"
            icon
            small
            outlined
          >
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0 text-dialog-scroll">
          <FormDinamicoReporte
            v-if="bMostrarFormDinamico"
            :sIDFormulario="itemEdit[sIdTable]"
            :sTabla="tabla"
            :sIdCliente="itemEdit[oPropsBoton.sCampoCliente]"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <div
    class="no-acceso"
    v-else-if="!cargando && aConfiguracion.permisos.priv_access == '0'"
  >
    <v-sheet color="dark" class="cont-tabla">
      <v-skeleton-loader
        :loading="false"
        class="mx-auto"
        max-width="100%"
        type="table-heading, table-thead, table-tbody, table-tfoot"
      >
      </v-skeleton-loader>
      <div class="mensaje">
        <div class="cont-icon">
          <v-icon size="40px" class="icon">mdi-lock-off-outline</v-icon>
        </div>
        <div class="texto-mensaje pa-3">
          <span class="text-primary font-size-1">
            No cuentas con permisos para ver esta aplicación.
          </span>
        </div>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import FilterSecction from "@/components/Grid/Filter_Component/FilterSecction.vue";
import axiosServices from "@/services/axiosServices.js";
import BtnEdit from "@/components/Grid/Btn_Component/BtnEdit.vue";
import BtnColor from "@/components/Grid/Btn_Component/BtnColor.vue";
import BtnDetalleCliente from "@/components/Grid/Btn_Component/BtnDetalleCliente.vue";
import BtnAddUser from "@/components/Grid/Btn_Component/BtnAddUser.vue";
import BtnMapa from "@/components/Grid/Btn_Component/BtnMapa.vue";
import BtnFirmas from "@/components/Grid/Btn_Component/BtnFirmas.vue";
import BtnImagenes from "@/components/Grid/Btn_Component/BtnImagenes.vue";
import formulario from "@/components/Form/Form.vue";
import ModalAddUser from "@/components/Grid/Btn_Component/FormAddUser.vue";
import ExportModal from "@/components/ExportExcel.vue";
import FormColor from "@/components/Grid/Btn_Component/FormColorCliente.vue";
import FormMapa from "@/components/Grid/Btn_Component/FormMapa.vue";
import editorhtml from "@/components/Grid/ComponentesCelda/CeldaHtmlEditor.vue";
import campoSwitch from "@/components/Grid/ComponentesCelda/CeldaSwitch.vue";
import campoSiNo from "@/components/Grid/ComponentesCelda/CeldaSiNo.vue";
import texto from "@/components/Grid/ComponentesCelda/CeldaTexto.vue";
import datetext from "@/components/Grid/ComponentesCelda/CeldaDateText.vue";
import numero from "@/components/Grid/ComponentesCelda/CeldaNumero.vue";
import selector from "@/components/Grid/ComponentesCelda/CeldaSelect.vue";
import dateRango from "@/components/Grid/ComponentesCelda/CeldaDateRango.vue";
import campoBuenoRegularNA from "@/components/Grid/ComponentesCelda/CeldaBuenoRegularNA.vue";
import correo from "@/components/Grid/ComponentesCelda/CeldaCorreo.vue";
import campoQR from "@/components/Grid/ComponentesCelda/CeldaQR.vue";
import campoNFC from "@/components/Grid/ComponentesCelda/CeldaNFC.vue";
import selectorMultiple from "@/components/Grid/ComponentesCelda/CeldaSelectorMultiple.vue";
import archivo from "@/components/Grid/ComponentesCelda/CeldaArchivo.vue";
import activoInactivo from "@/components/Grid/ComponentesCelda/CeldaActivoInactivo.vue";
import celdaChips from "@/components/Grid/ComponentesCelda/CeldaChips.vue";
import VistaDetalle from "@/components/Grid/Detalle/VistaDetalle.vue";
import BtnGrid from "@/components/Grid/Btn_Component/BtnGrid.vue";

import DialogFirmas from "@/components/Grid/Btn_Component/DialogFirmas.vue";
import DialogImagenes from "@/components/Grid/Btn_Component/DialogImagenes.vue";
import DialogAnexos from '@/components/Grid/Btn_Component/DialogAnexos.vue'

import BtnBuildCorreos from "@/components/Grid/Btn_Component/BtnBuildCorreos.vue";
import BtnEditGesDoc from "@/components/Grid/Btn_Component/BtnEditGesDoc.vue";

import TooltipContenido from "@/components/TooltipContenido.vue";
import BtnConvertir from "@/components/Grid/Btn_Component/BtnConvertir.vue";

import Pickcolor from "@/components/Grid/ComponentesCelda/CeldaPickcolor.vue";

import BtnEliminar from "@/components/Grid/Btn_Component/BtnEliminar.vue";
import FormDinamicoReporte from "@/components/FormDinamicos/FormDinamicoReporte.vue";

import { mapGetters } from "vuex";

import DialogoFechaRangoExportar from "@/components/Grid/DialogoFechaRangoExportar.vue";
export default {
  name: "GridComponent",
  components: {
    FilterSecction,
    BtnEdit,
    BtnColor,
    BtnDetalleCliente,
    BtnAddUser,
    BtnMapa,
    formulario,
    ModalAddUser,
    ExportModal,
    FormColor,
    FormMapa,
    editorhtml,
    campoSwitch,
    campoSiNo,
    texto,
    datetext,
    numero,
    selector,
    dateRango,
    correo,
    selectorMultiple,
    archivo,
    activoInactivo,
    VistaDetalle,
    BtnGrid,
    BtnFirmas,
    DialogFirmas,
    DialogAnexos,
    campoBuenoRegularNA,
    campoQR,
    campoNFC,
    BtnImagenes,
    DialogImagenes,
    BtnBuildCorreos,
    BtnEditGesDoc,
    TooltipContenido,
    celdaChips,
    BtnConvertir,
    Pickcolor,
    BtnEliminar,
    FormDinamicoReporte,
    DialogoFechaRangoExportar,
  },
  props: {
    tabla: {
      // Nombre de la tabla a trabajar
      type: String,
      default: "",
    },
    bUsarFiltro: {
      // validar si es necesario usar el filtro o no
      type: Boolean,
      default: true,
    },
    // DetallesCasoCorreo: {               //  Visualiza el detalle de la informacion se hace con el icono ojito
    //   type: String,
    //   default: ''
    // },
    bActiveFilter: {
      // Activa el Boton de Filtro
      type: Boolean,
      default: false,
    },
    bActiveExport: {
      // Activa el Boton de exportar
      type: Boolean,
      default: false,
    },
    bActiveSearch: {
      // Activa el buscar rapido - para buscar dentro de la infor visualizada
      type: Boolean,
      default: true,
    },
    bActiveNew: {
      // Actia el boton para de Nuevo en base a la tabla de FormularioTablas
      type: Boolean,
      default: true,
    },
    bSingleSelect: {
      type: Boolean,
      default: false,
    },
    bShowSelect: {
      type: Boolean,
      default: false,
    },
    bShowMapDetails: {
      type: Boolean,
      default: false,
    },
    sIdTable: {
      // nombre del pimary key de la tabla para ver los detalles - Si son mas de una se deben separar por comas "," siempre se debe poner el nombre real del campo
      type: String,
      default: "",
    },
    bGridAnidada: {
      // indica si se habilita la grid anidada
      type: Boolean,
      default: false,
    },
    bGridDetalle: {
      // Indica si se comportará como grid detalle o no
      type: Boolean,
      default: false,
    },
    nIdValor: {
      // Es el valor que se pasa al campo para filtrar, por lo general es un variable que modifica una grid en su select
      type: Number, // la cual emite el evento idSelect
      default: 0,
    },
    sCampoFiltro: {
      // indica el Nombre del campo para filtrar si es una tabla detall
      type: String,
      default: "",
    },
    aInfoTBDetalleExp: {
      type: Array,
      default: () => [],
    },
    aParametros: {
      type: Array,
      default: () => [], // Listado de string que contiene parametros adicionales que se usan para realizar filtrado, este listado son campos existentes.
    },
    bSubdominioTemporal: {
      //Indica que se activa puente con subdominio temporal
      type: Boolean,
      default: false,
    },
    nItemsPerPagina: {
      type: Number,
      default: 5,
    },
    aAccionesAdicionales: {
      type: Array,
      default: () => [], // es un listado de botones adicionales
    },
    altoTabla: {
      // Define la altura de la tabla se debe escribir el String con las unidades
      type: String,
      default: "60vh",
    },
    cabeceraVisible: {
      //Indica si se visualiza la cabecera de la grid o no
      type: Boolean,
      default: true,
    },
    bActualizar: {
      // se emplea para actualizar toda la grid - debido a que los props son lentos este seria un metodo confiable
      type: Boolean, // tener presente que en el evento onRefrescarItems  del padre se debe poner en false otravez
      default: false,
    },
  },
  data() {
    return {
      selected: [], // v-model de la tabla
      pageTotalVisible: 10, // Indica el numero de indicadores visibles en el paginados
      paginaselect: 1, // indica lando algo para mostrar el progres en la grid
      totalRegistros: 0, // indica el total de registros que se cargan en la grid
      headers: [], // Array de objetos que se cargan en la cabecera de la grid
      dataItems: [], // Data que se carga en la grid
      filtradoEstate: false, // estado de que si esta filtrando o no la grid
      BtnAcciones: [], // los botones que se muestran en la seccioa pagina seleccionada
      itemsPagina: [5, 10, 20, 50], // indica los item de numero de registros por pagina
      itemsPerPagina: this.nItemsPerPagina, // indica el item seleccionado en el control de registros por pagina
      quitSearch: "", // valor de la busqueda rapida
      cargando: true, // indica si se esta cargn (columna) de acciones
      showNew: false, // empleado para mostrar el form de new
      formNew: true, // indica en que modo se abre el formulario
      itemEdit: {}, // Item a ser editado
      keyForm: 0, // indice para re dibujar el form por cada apertura
      bShowAdd: false, // Habilita el modal de asignacion de usuarios
      oProps: {}, // Objeto donde se regresa el item de cada elemento donde se preciona un boton
      bShowEx: false, // Habilita el modal de exportación
      sPropsType: "", // Tipo archvio de exportación
      oParamsFiltro: {}, // Parametros de filtro para exportación
      nPropPageSel: 1, // Parametro de pagina seleccionada para exportar
      nPropsItemPerPage: 5, // Parametro de item por pagina que se exportara
      bExportAll: false, // Parametro para exportar toda la informacion o solo lo que se esta visualizando
      bMostrarFormDinamico: false, // Parametro para mostrar modal de dinamicos
      bShowColor: false, // Habilita el modal de asignación de color
      bShowMdlDet: false, // Id de la tabla que se esta presentando
      detalleVer: false, // Model para abrir detalle
      bShowMapa: false, // Habilita el modal del mapa con la ubicacion de lat y long
      bMostrarFirmas: false, // Habilita el dialog de firmas
      bMostrarImagenes: false, // Habilita el dialog de Imagenes
      bNewEditGesDoc: false, // Habilita La edicion de Gestion Documetnal
      countHeadersDetaills: 0, // Cuenta la cantidad de headers de la grid detalle
      aDataParaAnidada: [], // Data almacenada cuandose habilite la gridanidada,
      aFormatHeaders: [],
      aConfiguracion: {
        permisos: {
          // Contiene la configuracion de la tabla y permisos
          priv_access: "1",
          priv_insert: "1",
          priv_delete: "1",
          priv_update: "1",
        },
      },
      bFormularioTemporal: false, //indica que el formulario es temporal y se puede usar una tabla temporal
      sTablaTemporal: "", // nombre de la tabla temproal a usar,
      oDetalleFormulario: {}, // item seleccionaod para mostrarlo como un detalle en el formualrio
      sDetalleTitulo: "",
      oDataFormularioAdicional: {}, //Objecto sque se arma para enviar data adicional a un formulario
      aListadoFiltrosFinal: [], // se emplea
      bAnalizar: false, // Muestra el formulario para asociar riesgos a vulnerabilidad
      bConvertir: false, // Muestra el submenu para convertir vulnerabilidad
      bEvaluar: false, // Muestra el formulario para asociar riesgos a Evaluar
      bRecomendacion: false, // Muestra el formulario para evaluar las recomendaciones de riesgos
      sDetallesCasoCorreo: "", // Indica el casoCorreo a Visualiza en el detalle de la informacion se hace con el icono ojito
      nVistaTabla: 600, //Valor para el break point
      bMostrarOpciones: false, // Muestra las opciones en versión mobile

      bEditItem: false, // se empla para indicar que debo cargar el componente de Form por que se esta editanta desde el boton y este puede estar solo
      oPropsBoton: {}, // Se emplea para los reportes dinamicos d elos form
      bMostrarAnexos: false, // Muestra el formulario de anexos
      oValidacionBotones: {},
      bFiltrarActive: false, // Se activa la seccion de filtros
      aFiltrosActivos: [], // se emplea para recibir el arreglo de filtros activos
      bDialogoFechaExportar: false, // Valor para mostrar dialogo de rango de fecha para exportar
      aExportarTodo: [], //ARRAY PARA VALORES DE RANGO A EXPORTAR
    }; // fin return data
  }, // fin data
  async mounted() {
    if (this.tabla == "" || this.tabla == null) {
      return;
    }
    this.cargando = true;
    //validar si esta guardada la paginacion de la consulta en el storage
    if (localStorage.itemsPerPagina != undefined) {
      this.itemsPerPagina = parseInt(localStorage.itemsPerPagina);
    } else {
      localStorage.itemsPerPagina = this.itemsPerPagina;
    }

    await this.onGetDetallesCasoCorreo();
    await this.onGetHeaders();
    await this.onRefrescarItems();

    this.cargando = false;
  },
  methods: {
    on_aFiltrosActivos(aInfo) {
      this.aFiltrosActivos = aInfo;
    },
    on_aListadoFiltros(filtrosName) {
      this.aListadoFiltrosFinal = filtrosName;
    },
    async onRefrescarItems() {
      this.cargando = true;
      if (this.filtradoEstate) {
        await this.onGetConsultaFiltro();
        await this.onGetBtnAcciones();
      } else {
        this.$store.dispatch("filterSeccion/Clear_aInfoFiltrada");
        await this.onGetBtnAcciones();
        await this.onGetItems();
        await this.onGetTotalRegistros();
      }
      this.cargando = false;
      this.$emit("refrescarItems");
    },
    onDatosGuardados() {
      this.$emit("datosGuardados");
    },
    async onGetBtnAcciones() {
      this.cargando = true;
      let sParams = `sTable=${this.tabla}`;
      if (this.bSubdominioTemporal) {
        sParams =
          sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`;
      }
      const aAccionesBtn = await axiosServices.getConfiguration(
        "/pGrids_acciones",
        true,
        sParams
      );
      this.BtnAcciones = aAccionesBtn.aData;

      if (this.aAccionesAdicionales.length > 0) {
        this.oValidacionBotones = {};
        this.aAccionesAdicionales.forEach((item) => {
          const nValidar = this.BtnAcciones.findIndex(
            (oItem) => oItem.componente === item.componente && oItem.mensaje === item.mensaje
          );
          
          if (nValidar === -1) {
            this.BtnAcciones.push(item);
          } else {
            this.BtnAcciones[nValidar].oProps = item.oProps;
          }
          if (item.oProps.hasOwnProperty("aValidacionBoton")) {
            this.oValidacionBotones[item.componente] =
              item.oProps.aValidacionBoton;
          }
          
        });        
      }
      this.formatHeader();
    },
    async onGetTotalRegistros() {
      if (this.tabla == "" || this.tabla == null) {
        return;
      }
      this.cargando = true;
      var sParams = "";
      var sPeticion = "";
      let sParamsAdicionales = this.onExtraerParametros();
      if (this.bGridDetalle) {
        sParams = `sTable=${this.tabla}&sIdForeignKey=${this.sCampoFiltro}&nIdValue=${this.nIdValor}${sParamsAdicionales}`;
        sPeticion = "/dGrids_totalregistros";
      } else {
        sParams = `sTable=${this.tabla}${sParamsAdicionales}`;
        sPeticion = "/pGrids_totalregistros";
      }
      if (this.bSubdominioTemporal) {
        sParams =sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`;
      }
      const { aData } = await axiosServices.getConfiguration(
        sPeticion,
        true,
        sParams
      );
      this.totalRegistros = aData[0]["Cantidad"];
      // this.cargando = false;
    },
    async onGetHeaders() {
      if (this.tabla == "" || this.tabla == null) {
        return;
      }
      let sParams = `sTable=${this.tabla}&nPerfil=${this.$store.state.idPerfil}`;

      if (this.bSubdominioTemporal) {
        sParams =
          sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`;
      }
      const aConf = await axiosServices.getConfiguration(
        "/pGrids_permisos",
        true,
        sParams
      );
      this.aConfiguracion = aConf.aData;
      const aHeaders = await axiosServices.getConfiguration(
        "/pGrids_headers",
        true,
        sParams
      );
      this.headers = aHeaders.aData;
      if (this.bGridDetalle) {
        window.scrollTo({ top: 400, left: 0, behavior: "smooth" });
      }
      this.formatHeader();
    },
    async onGetItems() {
      if (this.tabla == "" || this.tabla == null) {
        return;
      }
      this.cargando = true;
      var sParams = "";
      var sPeticion = "";
      this.dataItems = [];
      let sParamsAdicionales = this.onExtraerParametros();
      if (this.bGridDetalle) {
        sParams = 'nopagina='+ this.paginaselect + '&' + 'noregistros=' + this.itemsPerPagina + `&sTable=${this.tabla}` + `&sIdForeignKey=${this.sCampoFiltro}` + `&nIdValue=${this.nIdValor}${sParamsAdicionales}`
        sPeticion = "/dGrids";
      } else {
        sParams =
          "nopagina=" +
          this.paginaselect +
          "&" +
          "noregistros=" +
          this.itemsPerPagina +
          `&sTable=${this.tabla}${sParamsAdicionales}`;
        sPeticion = "/pGrids";
      }
      if (this.bSubdominioTemporal) {
        sParams =
          sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`;
      }
      axiosServices
        .getConfiguration(sPeticion, true, sParams)
        .then((adataItems) => {
          this.cargando = false;
          this.dataItems = adataItems.aData;
        });
    },
    onExportar(tipoArchivo, val) {
      if (val === "rango") {
        this.sPropsType = tipoArchivo;
        this.bDialogoFechaExportar = true;
      } else {
        this.sPropsType = tipoArchivo;
        this.bShowEx = true;
        this.bExportAll = false;
      }
    },
    onRangoExportar(val) {
      //  Recibe el Array con la fecha inicio y final del componente de calendario
      this.aExportarTodo = val; // Regresa el Array al componente de exportar
      this.bExportAll = true;
      this.bShowEx = true;
    },
    exportinfo() {
      this.$analytics.logEvent("Grid-" + this.tabla + "", { exportarGrid: 1 });
    },
    nuevoItem() {
      this.keyForm += 1;
      this.itemEdit = {};
      this.formNew = true;
      this.showNew = !this.showNew;
      this.bFormularioTemporal = false;
      this.sTablaTemporal = "";
      this.oDetalleFormulario = {};
      this.sDetalleTitulo = "";
      this.oDataFormularioAdicional = {};
    },
    onFiltrar() {
      this.bFiltrarActive = true;
      this.$analytics.logEvent("Grid-" + this.tabla + "", { filtrarGrid: 1 });
    },
    onExtraerParametros() {
      let sParamsAdicionales = "";
      this.aParametros.forEach((sPar) => {
        if (sPar.includes("="))
          sParamsAdicionales = sParamsAdicionales + `&${sPar}`;
      });
      return sParamsAdicionales;
    },
    onGetFiltrarInicio(oFiltro) {
      // como se dio click en ejecutar del filtro reinicio la pagina el nopagina
      this.paginaselect = 1;
      this.onGetConsultaFiltro(oFiltro);
    },
    async onGetConsultaFiltro(oFiltro = {}) {
      if(this.tabla==''||this.tabla==null){
        return;
      }
      this.cargando = true
      let sParams  = ''
      let endPoint = ''
      // se mira si se trae filtro o no 
      this.oParamsFiltro = (!this.filtradoEstate&&this.bUsarFiltro) ? oFiltro : this.oParamsFiltro
      // una vez que se indique que trae el filtro
      this.filtradoEstate = true
      let sParamsAdicionales = this.onExtraerParametros()
      if(this.bGridDetalle) {
        sParams = 'nopagina='+ this.paginaselect + '&' + 'noregistros=' + this.itemsPerPagina +  '&' + 'filtros=' + JSON.stringify(this.oParamsFiltro) + `&sTable=${this.tabla}` + 
                  `&sIdForeignKey=${this.sCampoFiltro}&nIdValue=${this.nIdValor}${sParamsAdicionales}`
        endPoint = '/dGrids_filtrar'
      } else {
        sParams = 'nopagina='+ this.paginaselect + '&' + 'noregistros=' + this.itemsPerPagina +  '&' + 'filtros=' + JSON.stringify(this.oParamsFiltro) + `&sTable=${this.tabla}${sParamsAdicionales}`
        endPoint = '/pGrids_filtrar'
      }
      if(this.bSubdominioTemporal){
        sParams = sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
      }
      this.$emit(                           // Se emite que se filtro
          'filtrando',                       
          { 
            oParamsFiltro  : this.oParamsFiltro, 
            aListadoFiltrosFinal  : this.aListadoFiltrosFinal,
            aFiltrosActivos : this.aFiltrosActivos,  
          } 
      )  
      this.dataItems = []
      const aFilter = await axiosServices.getConfiguration(endPoint, true, sParams)
      this.totalRegistros = aFilter.aData['TotalRegistros'][0].Cantidad
      this.dataItems = aFilter.aData['Data']
      this.cargando = false;
    },
    onLimpiarFiltros() {
      this.oParamsFiltro = "";
      this.filtradoEstate = false;
      this.$store.dispatch("filterSeccion/Clear_aInfoFiltrada");
      this.$emit("filtrando", null); // Se emite que se limpiarion los filtro por eso el null y no objeto vacio
      this.$emit("LimpiarFiltros"); //
      this.onRefrescarItems();
    },
    btnActionEvento(oEvento) {
      // manejo de evento de los tonones de action
      // lleva un objeto con {btnname: '' , item: ''
      switch (oEvento.btnName) {
        case "btnEliminar": {
          this.formNew = false;
          this.itemEdit = { ...oEvento.item };
          this.onEliminarItem();
          break;
        }
        case "btnFormulario": {
          this.itemEdit = { ...oEvento.item };
          if (oEvento.oProps.sCampoCliente !== undefined) {
            this.oPropsBoton = oEvento.oProps;
          }
          this.bMostrarFormDinamico = true;

          break;
        }
        case "btnEdit": {
          this.bEditItem = true;
          this.keyForm += 1;
          this.formNew = false;
          this.itemEdit = { ...oEvento.item };
          this.showNew = !this.showNew;
          break;
        }
        case "btnAddUser": {
          this.keyForm += 1;
          this.bShowAdd = true;
          this.oProps = oEvento.item;
          break;
        }
        case "btnColor": {
          this.keyForm += 1;
          this.bShowColor = true;
          this.oProps = oEvento.item;
          break;
        }
        case "btnEditarSAC": {
          this.keyForm += 1;
          // hago un emit para que active el modal de edicion en reportes sac
          this.oProps = oEvento.item;
          this.$emit("onBtnEditarSac", { ...oEvento.item }, oEvento.oProps.sNombre, { ...this.oDetalleFormulario });
          break;
        }
        case "btnDetails": {
          this.keyForm += 1;
          // this.bShowMdlDet = true;
          this.oProps = oEvento.item;
          this.detalleVer = true //Muestra el componente lateral de la vista de detalle
          this.$analytics.logEvent('Grid-'+this.tabla+'', { verDetalle:1}) //Analitics
          break;
        }
        case "btnMapa": {
          this.pagina = 1;
          this.keyForm += 1;
          this.oProps = oEvento.item;
          this.bShowMapa = true; //Muestra el componente lateral de la vista de detalle
          break;
        }
        case "btnFirmas": {
          this.oProps = oEvento.item;
          this.bMostrarFirmas = true;
          break;
        }
        case "btnAnexos": {
          this.oProps = oEvento.item;
          this.bMostrarAnexos = true;
          break;
        }
        case "btnImagenes": {
          this.oProps = oEvento.item;
          this.bMostrarImagenes = true;
          break;
        }
        case "btnBuildCorreos": {
          this.keyForm += 1;
          this.itemEdit = { ...oEvento.item };
          this.$router.replace({
            name: "buildCorreos",
            params: {
              idCorreos: this.itemEdit.id_correos,
              oCorreo: this.itemEdit,
            },
          });
          break;
        }
        case "btnDinamico": {
          this.oDetalleFormulario = {
            items: oEvento.item,
            headers: this.headers,
          };

          this.$emit(
            "onBtnDinamico",
            { ...oEvento.item },
            oEvento.oProps.sNombre,
            { ...this.oDetalleFormulario }
          );
          break;
        }
        case "btnAgregarObs": {
          this.keyForm += 1;
          // hago un emit para que active el modal de edicion en reportes sac
          this.oProps = oEvento.item;
          this.$emit("onBtnAgregarObs", { ...oEvento.item }, oEvento.oProps.sNombre, { ...this.oDetalleFormulario });
          break;
        }
        case "btneGestionar": {
          if (oEvento.oProps.sTablaFormulario !== undefined) {
            this.keyForm += 1;
            this.itemEdit = {};
            this.formNew = true;
            this.showNew = !this.showNew;
            this.bFormularioTemporal = true;
            this.sTablaTemporal = oEvento.oProps.sTablaFormulario;
            if (
              Object.prototype.hasOwnProperty.call(
                oEvento.oProps,
                "aParametrosEnvio"
              )
            ) {
              oEvento.oProps.aParametrosEnvio.forEach((oItem) => {
                const sParametroExtraccion =
                  Object.prototype.hasOwnProperty.call(oItem, "sCampoExtraer")
                    ? oItem.sCampoExtraer
                    : oItem.sParametro;
                let bEncontrado = false;
                this.aParametros.forEach((sPar) => {
                  if (sPar.includes("=")) {
                    if (sPar.split("=")[0] == sParametroExtraccion) {
                      bEncontrado = true;
                      this.oDataFormularioAdicional[oItem.sParametro] =
                        sPar.split("=")[1];
                      return;
                    }
                  }
                });
                if (!bEncontrado) {
                  Object.keys(oEvento.item).forEach((sKey) => {
                    if (sParametroExtraccion == sKey) {
                      this.oDataFormularioAdicional[oItem.sParametro] =
                        oEvento.item[sKey];
                      bEncontrado = true;
                      return;
                    }
                  });
                }
              });
            }
          }
          if (oEvento.oProps.bDetalleFormulario !== undefined) {
            this.oDetalleFormulario = oEvento.oProps.bDetalleFormulario
              ? { items: oEvento.item, headers: this.headers }
              : {};
          }
          if (oEvento.oProps.sDetalleTitulo !== undefined) {
            this.sDetalleTitulo = oEvento.oProps.sDetalleTitulo;
          }

          break;
        }
        case "btnEditGesDoc": {
          this.oProps = oEvento.item;
          this.bNewEditGesDoc = true;
          break;
        }
        case "btnConvertir": {
          this.oProps = oEvento.item;
          this.bConvertir = true;
          break;
        }
        case "btnGenerico": {
          this.oProps = oEvento.item;
          this.$emit(
            "onBtnGenerico", { ...oEvento.item }, oEvento.oProps.sNombre,
          );
          break;
        }
        default: {
          break;
        }
      }
    },
    setModalFalse(bNewValue) {
      this.bShowAdd = bNewValue;
      this.bShowEx = bNewValue;
      this.bShowColor = bNewValue;
      this.bShowMdlDet = bNewValue;
      this.bShowMapa = bNewValue;
      this.bMostrarFirmas = bNewValue;
      this.bMostrarImagenes = bNewValue;
      this.bAnalizar = bNewValue;
      this.bConvertir = bNewValue;
      this.bEvaluar = bNewValue;
      this.bRecomendacion = bNewValue;
    },
    getColor(item, NombreCampo) {
      return item[`Color_${NombreCampo}`];
    },
    getAlineacion(alineacion) {
      switch (alineacion) {
        case "1":
          return "text-center";
        case "2":
          return "text-right";
        case "3":
          return "text-left";
        case "4":
          return "text-justify";
        default:
          return "text-center";
      }
    },
    async onEliminarItem() {
      let sParams = "sTable=" + this.onCargarOrigenFormulario("Tabla");
      let oPut = {};
      oPut.viejo = this.itemEdit;
      if (this.sIdTable.indexOf(",") !== -1) {
        // Como vienen dos o mas de dos primero split (convierto en array) el texto
        const aIDItem = this.sIdTable.split(",");
        // recorro el array y creo un string para pasarlos a
        let oItemResp = {};
        aIDItem.forEach((sItem) => (oItemResp[sItem] = this.oItem[sItem]));

        oPut.viejo.id = oItemResp;
      } else {
        oPut.viejo.id = this.itemEdit[this.sIdTable];
      }

      let oResponse = await axiosServices.deleteConfiguration(
        "/formulario",
        oPut,
        true,
        sParams
      );
      if (oResponse.sStatus == "success") {
        this.$swal({
          timer: 1500,
          icon: `${oResponse.sStatus}`,
          title: `${oResponse.sMessage}`,
          showConfirmButton: false,
        });
        this.itemEdit = {};
        this.onRefrescarItems();
      }
    },
    formatHeader() {
      this.aFormatHeaders = [];
      // le doy formato al header añadiendo align: 'center', sortable: true OJO todo es un texto en value
      // valido si el ultimo elemento es value -- actinos para no meterlo  qque sea mayor que 0
      // if(this.BtnAcciones.length > 0 && this.headers.length > 0 && Headers[Headers.length -1].value !== 'actions'){
      if (
        this.BtnAcciones.length > 0 &&
        this.headers.length > 0 &&
        (this.aConfiguracion.info.pos_botones == "1" ||
          this.aConfiguracion.info.pos_botones == "2")
      ) {
        this.aFormatHeaders.push({
          value: "actions",
          text: "ACCIONES",
          filtro: "0",
          visible: "1",
          width: "200",
          tipo: "",
          InnerJoin: "",
          align: "center",
          divider: true,
          class: "titlesdark--text font-weight-bold",
        });
      }

      if(this.headers) {
        this.headers.forEach((oValor) => {
          this.aFormatHeaders.push(oValor);
        });
      }
      let aBorrar = [];
      // const sEXP_Color = '/^Color_*/'
      this.aFormatHeaders.forEach((value, Key) => {
        if (value.visible == "0") {
          aBorrar.push(Key);
        }
        this.aFormatHeaders[Key].align = "center";
        this.aFormatHeaders[Key].sortable = true;
        this.aFormatHeaders[Key].divider = true;
        this.aFormatHeaders[Key].class = "titlesdark--text font-titulo";
      });

      if (
        this.BtnAcciones.length > 0 &&
        this.headers.length > 0 &&
        (this.aConfiguracion.info.pos_botones == "0" ||
          this.aConfiguracion.info.pos_botones == "2")
      ) {
        this.aFormatHeaders.push({
          value: "actions",
          text: "ACCIONES",
          filtro: "0",
          visible: "1",
          width: "200",
          tipo: "",
          InnerJoin: "",
          align: "center",
          divider: true,
          class: "titlesdark--text font-weight-bold",
        });
      }

      aBorrar.forEach((value, key) => {
        // pora cada borrado toca restar el key del value
        this.aFormatHeaders.splice(value - key, 1);
      });
    },
    onCargarOrigenFormulario(sTipo) {
      switch (sTipo) {
        case "Tabla":
          return this.bFormularioTemporal ? this.sTablaTemporal : this.tabla;
      }
    },
    async onGetDetallesCasoCorreo() {
      let sParams = `sTable=${this.tabla}`;
      if (this.bSubdominioTemporal) {
        sParams =
          sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`;
      }
      const { aData } = await axiosServices.getConfiguration(
        "/pGrids_DetalleCasosCorreo",
        true,
        sParams
      );
      if (!(typeof aData === "boolean")) {
        this.sDetallesCasoCorreo = aData.length == 0 ? "" : aData[0].nombre_correo;
      }
    },
    onCeldaCambio(sTipo, bValor) {
      this.$emit("onCambioInfo", sTipo, bValor);
    },
    onValidarBoton(sComponente, oData) {
      let bMostrar = true;

      if (this.oValidacionBotones.hasOwnProperty(sComponente)) {
        
        this.oValidacionBotones[sComponente].forEach((oItem) => {
          switch (oItem.sComparador) {
            case "!==":
              {
                bMostrar = bMostrar && oData[oItem.sCampo] !== oItem.sValor;
              }
              break;
            case "===":
              {
                bMostrar = bMostrar && oData[oItem.sCampo] === oItem.sValor;
              }
              break;
          }
        });
      }
      else if (sComponente == "BtnGenerico") {
        const oComponenteGenerico = this.aAccionesAdicionales.find(item => item.componente == "BtnGenerico");

        if (oComponenteGenerico?.aCondiciones) {
          //recorremos todas las condiciones para validar si la respuesta es correcta o incorrecta
          oComponenteGenerico.aCondiciones.forEach(oCondicion => {
            switch (oCondicion.sCondicion) {
              case "==":
                if (oCondicion.sDato != oData[oCondicion.sColumna]) {
                  bMostrar = false;
                }
                break;
              case "!=":
                if (oCondicion.sDato == oData[oCondicion.sColumna]) {
                  bMostrar = false;
                }
                break;
            }
          });
        }
      }

      return bMostrar;
    },
  },
  computed: {
    cmpGetoParamsFiltro() {
      if (this.oParamsFiltro != "") {
        return this.oParamsFiltro;
      } else {
        return {};
      }
    },
    pageLength() {
      return Math.ceil(this.totalRegistros / this.itemsPerPagina);
    },
    cmpAltoTabla() {
      return this.altoTabla;
    },
    ...mapGetters("filterSeccion", ["getaInfoFiltrada", "getoParamsFiltro"]),
  },
  watch: {
    paginaselect() {
      this.onRefrescarItems();
      this.nPropPageSel = this.paginaselect;
    },
    pageLength(NewValue, OldValue) {
      if (NewValue !== OldValue) {
        if (this.pageLength < this.paginaselect)
          this.paginaselect = this.pageLength;
      }
    },
    itemsPerPagina() {
      localStorage.itemsPerPagina = this.itemsPerPagina;
      this.nPropsItemPerPage = this.itemsPerPagina;
      this.paginaselect = 1;
      this.onRefrescarItems();
    },
    selected(aNewValue, aOldValue) {
      // valido si se quita algo antes que nada
      const aux_aElementoQuitado = aOldValue.filter(
        (elemento) => aNewValue.indexOf(elemento) == -1
      );
      if (aux_aElementoQuitado.length > 0) {
        // indico cual se quito emitiendolo negativo
        aux_aElementoQuitado.forEach((ElementoQuitado) => {
          if (ElementoQuitado.hasOwnProperty(`id${this.tabla}`)) {
            this.$emit(
              "idSelect",
              parseInt(ElementoQuitado[`id${this.tabla}`]) * -1
            );
          } else {
            this.$emit(
              "idSelect",
              parseInt(ElementoQuitado[this.sIdTable]) * -1
            );
          }
        });
      }
      if (aNewValue.length == 0) {
        // this.$emit('idSelect', 0)
        this.$emit("nameField", "");
        this.$emit("oItemSeleccionado", {});
      }
      aNewValue.forEach((oElement) => {
        if (oElement.hasOwnProperty(`id${this.tabla}`)) {
          this.$emit("nameField", Object.keys(oElement)[0]);
          this.$emit("idSelect", parseInt(oElement[`id${this.tabla}`]));
        } else {
          this.$emit("nameField", this.sIdTable);
          this.$emit("idSelect", parseInt(oElement[this.sIdTable]));
        }
        this.$emit("oItemSeleccionado", oElement);
      });
    },
    nIdValor(sNewValue, sOldValue) {
      if (sNewValue != sOldValue) {
        this.onRefrescarItems();
      }
    },
    bActualizar() {
      if (this.bActualizar) {
        // this.bActualizar = false
        this.onRefrescarItems();
      }
    },
  },
};
</script>

<style lang="scss" >
.rounded-basic {
  border-radius: 13px !important;
}
.v-data-table-header {
  background-color: #f5f6fa !important;
}
/* .v-icon.notranslate.fas.fa-check-square.theme--light{ */
.v-data-table__checkbox.v-simple-checkbox i {
  font-size: 14px !important;
}
.HeaderOculto {
  display: none;
}
.v-data-table td {
  font-size: 0.7rem !important;
}

// Ajuste del tamaño del icono de busqueda
.v-input__icon--append {
  i {
    font-size: 20px !important;
  }
}

.v-pagination__item {
  box-shadow: none !important;
  color: var(--v-colortextinfo-base) !important;
}
// Ajuste de color en la paginación de la grid
.v-pagination__navigation {
  box-shadow: none !important;
}
.v-pagination__item--active {
  color: white !important;
}
.container-search {
  font-size: 0.8em !important;
  @media screen and (max-width: 600px) {
    transform: scale(0.9);
  }
}
.cont-acciones {
  margin-left: auto !important;
}
.font-titulo {
  font-weight: 500 !important;
  line-height: 1.2em;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.col-nopadding {
  padding: 0 !important;
}
.resaltado {
  border: solid 1px var(--v-primary-base);
  text-align: center;
  line-height: 0.8em;
  display: flex;
  justify-items: center;
  align-items: center;
  padding: 6px 4px;
  border-radius: 3px;
  font-size: 1em;
  margin-left: 4px;
  color: var(--v-primary-base);
}
.container {
  padding: 0px 2px !important;
}
.select-registros .v-input__slot {
  max-width: 70px;
  font-size: 0.9em;
}
.text-registros {
  font-size: 9pt;
}
.text-registros-totales {
  font-size: 9pt;
}
.container__comp--btn {
  display: flex;
  justify-content: center;
}
.item-action {
  min-width: auto !important;
}
.no-acceso {
  margin: 0;
  height: 70vh;
  position: relative;
  text-align: center;
  .mensaje {
    position: absolute;
    margin: 0 auto;
    top: 20%;
    width: 100%;
  }

  .cont-icon {
    background: linear-gradient(
      0deg,
      rgba(218, 218, 218, 1) 0%,
      rgba(238, 238, 238, 1) 100%
    );
    width: 80px;
    height: 80px;
    border: solid #fff 1px;
    box-shadow: 0 0 10px 3px rgba($color: #000000, $alpha: 0.2);
    margin: 0 auto;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    i {
      font-size: 55px;
      color: var(--v-primary-base);
    }
  }
  .texto-mensaje {
    border-radius: 10px;
    border: solid #fff 1px;
    margin-top: 5px;
    background: linear-gradient(
      0deg,
      rgba(218, 218, 218, 0.6) 0%,
      rgba(238, 238, 238, 0.6) 100%
    );
  }
}
.titulo-filtro {
  font-size: 10em;
}
.titulo-filtros {
  font-size: 12pt;
}
.filtros-activos-mensaje {
  width: 100%;
  border-radius: 5px;
  color: var(--v-primarydark-base);
  padding: 2px 5px;
  font-size: 11pt;
  background: #9ad0ec;
}
.filtros-activos {
  font-size: 10pt;
}
.close-btn {
  position: absolute;
  right: 20px;
  top: 0px;
}
.font-grid {
  font-size: 1em;
}
.cont-dialog-scroll {
  .text-dialog-scroll {
    max-height: 80vh;
    overflow-y: auto;
  }
}
.item-btn-more {
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 5px;
}
.cont-btn-more {
  width: 100%;
  background: white;
}
</style>